module.exports = __webpack_public_path__ + "img/Number=34.98db0abb.png";